import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import {
  AuthCookieService,
  AuthService,
  IdleService,
  SignalRService,
} from '@vinnova/auth';
import { BetalningsuppgiftReminderService } from '@vinnova/e-tjanster';
import { TranslateService } from '@vinnova/translation';
import { AnalyticsInitializerService } from '@vinnova/utilities';
import { catchError, throwError } from 'rxjs';
import { environment } from '../environments/environment';
import { ClassificationService } from './core/services/classification.service';

@UntilDestroy()
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit {
  constructor(
    private authCookieService: AuthCookieService,
    private authService: AuthService,
    private translateService: TranslateService,
    private idleService: IdleService,
    private signalRService: SignalRService,
    private classificationService: ClassificationService,
    private router: Router,
    private betalningsuppgiftReminderService: BetalningsuppgiftReminderService,
    private analyticsInit: AnalyticsInitializerService,
  ) {}

  async ngOnInit() {
    this.authService
      .onLoggedIn([
        this.classificationService.fetchAllClassifications().pipe(
          catchError((err) => {
            this.router.navigateByUrl('/error', {
              skipLocationChange: true,
            });
            return throwError(() => err);
          }),
        ),
        this.idleService.initIdle(),
      ])
      .pipe(untilDestroyed(this))
      .subscribe();

    this.authService
      .onLoggedIn()
      .pipe(untilDestroyed(this))
      .subscribe(() => {
        this.signalRService.init(
          [
            `https://${environment.b2cMsalConfig.tenant}.onmicrosoft.com/${environment.b2cMsalConfig.clientId.etjansterCommonApiClientId}/all`,
          ],
          environment.b2cMsalConfig.authority,
        );
        this.betalningsuppgiftReminderService.showBetalningsuppgiftReminderModal();
      });

    this.translateService
      .setActiveLang()
      .pipe(untilDestroyed(this))
      .subscribe();

    this.authCookieService
      .tokenSuccess()
      .pipe(untilDestroyed(this))
      .subscribe();

    await this.analyticsInit.load(environment.ga4MeasurementId);
  }
}
